import { Typography } from '../../components';
import { Container, GridContainer, GridTile, ZorgProfImg, ZorgProfTitle } from './styled';
import { Link } from 'react-router-dom';

const loadImages = require.context('../../assets/images/illustrations', true);

export default function Gesprek(props) {
    const IconGrid = () => {
            const illustrationList = [
                { name: 'lactatiekunde' },
                { name: 'verloskunde' },
                { name: 'kraamzorg' },
                { name: 'jgz' },
                { name: 'huisarts' },
                { name: 'ziekenhuis' },
                { name: 'gemeenten' },
            ]
    
            return (
                <GridContainer>
                    {illustrationList.map((item, i) => {
                        return (
                            <GridTile as={Link} to={`/gesprek/${item.name}`} key={i}>
                                <ZorgProfTitle>{item.name}</ZorgProfTitle>
                                <ZorgProfImg src={loadImages(`./${item.name.toLocaleLowerCase()}.png`)} alt={item.name} loading='lazy' />
                            </GridTile>
                        )
                    })}
                </GridContainer>
            )
        }

    return (
        <Container>
            <Typography type='h1' style={{ color: '#114d55' }}>Plan een gesprek</Typography>
            <Typography style={{ color: '#114d55', margin: '5em 0 1em 0' }}>Klik op de groep waartoe jij behoort</Typography>
            <IconGrid />
        </Container>
    )
}